import type { App } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

export function setupReCaptcha(app: App) {
  app.use(VueReCaptcha, {
    siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    loaderOptions: {
      useRecaptchaNet: true,
      autoHideBadge: true,
      explicitRenderParameters: {
        badge: 'bottomright',
      },
    },
  })
}
